import { Component } from '@angular/core';
import { BaseComponent } from 'base-form';

@Component({
  selector: 'mfpc-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss']
})
export class TextInputComponent extends BaseComponent {}
